import React from "react";
import Content from "./Content";
import PreviewCompatibleImage from "./PreviewCompatibleImage";
import SharingWidget from "./SharingWidget";
import ThreeLinkBlock from "../components/ThreeLinkBlock";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const PostTemplate = ({
  content,
  contentComponent,
  title,
  helmet,
  headline,
  subtitle,
  image,
  url
}) => {
  const PostContent = contentComponent || Content;

  return (
    <>
      {helmet || ""}
      <Row className="py-3">
        <Col className="col-12 col-md-8 offset-md-2">
          <div>
            <i className="fas fa-caret-down laas-text-dr"></i>
          </div>
          <h1 className="font-cb laas-text-dr">{headline}</h1>
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-8 offset-md-2">
          <PreviewCompatibleImage
            imageInfo={{
              image,
              alt: `featured image thumbnail for post ${title}`
            }}
          />
        </Col>
      </Row>
      <Row className="py-5">
        <Col className="col-12 col-md-6 offset-md-3">
          <div>
            <i className="fas fa-caret-down laas-text-dr"></i>
          </div>
          <h2 className="font-cb laas-text-dr">{title}</h2>
          <h3>{subtitle}</h3>
          <SharingWidget url={url} title={title} className="py-2" />
          <PostContent content={content} className="text-line-height font-cr" />
        </Col>
      </Row>
      <ThreeLinkBlock />
    </>
  );
};

export default PostTemplate;
